// export * from "./FeatureObject";
import {UserAccount} from '../../__generated__/resolvers-types';
import {FeatureObject} from '../../types/FeatureObject';
import {FeatureStatus} from '../../types/FeatureStatus';
import {env} from '../../constants';
import {filterByExcludeStatus} from '../../util/feature/filterByExcludeStatus';
import {filterByExcludeTags} from '../../util/feature/filterByExcludeTags';
import {filterByIncludeStatus} from '../../util/feature/filterByIncludeStatus';
import {filterByPermission} from '../../util/feature/filterByPermission';
import {filterForOwner} from '../../util/feature/filterForOwner';
import * as authClaims from './authClaims';
import * as contactMessages from './contactMessages';
import * as couponCodes from './couponCodes';
import * as environment from './environment';
import * as etsyAccounts from './etsyAccounts';
import * as featureUsage from './featureUsage';
import * as gdriveAccounts from './gdriveAccounts';
import * as subscription from './subscription';

const settings = {
  ...authClaims,
  ...contactMessages,
  ...couponCodes,
  ...environment,
  ...etsyAccounts,
  ...featureUsage,
  ...gdriveAccounts,
  ...subscription,
};

/**
 * Get all feature objects
 * - used for building router
 * @returns all features
 */
export function getAllSettings(): FeatureObject[] {
  return Object.values(settings).filter((s) => (env.subscribe ? true : filterByExcludeTags('subscription')(s)));
}

/**
 * Generate setting list
 * @param user
 * @param filters
 * @returns
 */
export function getSettings(
  user?: UserAccount | null,
  filters?: {includeStatus?: FeatureStatus[]; excludeStatus?: FeatureStatus[]},
): FeatureObject[] {
  return getAllSettings()
    .filter(filterByExcludeStatus([FeatureStatus.PLANNED])) // planned features does not exists, only for external website
    .filter(filterByPermission(user)) // only show features that user has permission to see
    .filter(filterForOwner(user)) // filter for owner/admin features
    .filter(filterByIncludeStatus(filters?.includeStatus)) // filter by include status
    .filter(filterByExcludeStatus(filters?.excludeStatus)) // filter by exclude status
    .filter(filterByExcludeTags('skipMenu')); // filter by exclude status
}
